import React from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';

//import Components
import Header from './Header';
import MobileMenu from './MobileMenu';
import Footer from './Footer';

const Layout = (props : any) => {

    document.documentElement.setAttribute('data-layout', 'horizontal');
    
    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header headerclassName={"topbar-shadow"} />
                <MobileMenu />
                <div className="main-content">
                    {props.children}
                    <Footer />
                </div>
            </div>
        </React.Fragment>
    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);